import React from "react";
import Header from "../shared/Header";
import Sidebar from "../shared/Sidebar";
import "../index.css";

const Layout = ({ component }) => {
  return (
    <>
      <div
        className=" bg-secondary w-full"
        style={{
          background:
            "linear-gradient(180deg, rgba(2, 0, 40, 1) 0%, rgba(1, 0, 75, 1) 49%, rgba(2, 0, 95, 1) 65%, rgba(2, 0, 120, 1) 100%)",
        }}
      >
        <div className="sticky z-50 top-0">
          <Header />
        </div>
        <div className="flex justify-between bg-secondary">
          <div
            className="!z-30 text-black shadow-card !opacity-80 shadow-red-500"
            style={{ width: "18%" }}
          >
            <Sidebar />
          </div>
          <div
            className="text-gray-400  w-full float-right bg-slate-100 overflow-y-auto"
            style={{ width: "82%" }}
          >
            {component}
            <div className="absolute !bottom-0 !bg-slate-200 shadow shadow-red-400 opacity-95 trans rounded p-2 !right-0 m-1 text-xl" 
            >
              Powered By ERP
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
